/**
 * src/modules/form-values.ts — odczyt wartości formularza odporny na
 * anty-autofill (2026-08-25).
 *
 * DLACZEGO ISTNIEJE: `_anti-autofill.ts` broni się przed podpowiedziami adresu
 * w Chrome, USUWAJĄC atrybut `name` z pól adresowych (street, city, company,
 * phone, sender_… , receiver_… ). Komentarz w tamtym module zakładał, że
 * „wewnętrzny JS SellBase czyta po id, więc usunięcie name nie szkodzi" —
 * i to założenie było fałszywe: kilka formularzy czyta wartości WŁAŚNIE po
 * `name` (przez FormData). Efekt: pola wyglądają normalnie, user je wypełnia,
 * a na serwer leci pustka. Bez błędu, bez śladu.
 *
 * Zmierzone (produkcja, 2026-08-25, konto DPD): w oknie edycji konta
 * kurierskiego z dziewięciu pól nadawcy w dokumencie zostało JEDNO —
 * `sender_email` — bo jako `type="email"` nie podlega tamtej ochronie.
 * Pozostałe osiem straciło `name`, więc zapis wysyłał puste dane nadawcy.
 *
 * Ten moduł czyta nazwę pola z `name` ALBO z `data-sb-name`, gdzie
 * anty-autofill odkłada oryginał. Formularze mają używać tych funkcji
 * zamiast `new FormData(...)`.
 */

/** Nazwa kontrolki: bieżąca albo odłożona przez anty-autofill. */
export function nazwaKontrolki(el: any): string {
  if (!el) return '';
  const wprost = String(el.getAttribute?.('name') || el.name || '');
  if (wprost) return wprost;
  return String(el.getAttribute?.('data-sb-name') || '');
}

/**
 * Wartości wszystkich kontrolek w podanym elemencie (formularz, okno modalne,
 * dowolny kontener). Pola wyłączone pomijamy — tak samo jak FormData.
 */
export function wartosciFormularza(kontener: any): Record<string, any> {
  const dane: Record<string, any> = {};
  if (!kontener || typeof kontener.querySelectorAll !== 'function') return dane;
  const kontrolki = kontener.querySelectorAll('input, select, textarea');
  for (let i = 0; i < kontrolki.length; i++) {
    const el: any = kontrolki[i];
    const nazwa = nazwaKontrolki(el);
    if (!nazwa || el.disabled) continue;
    const typ = String(el.type || '').toLowerCase();
    if (typ === 'checkbox') { dane[nazwa] = el.checked ? '1' : '0'; continue; }
    if (typ === 'radio') { if (el.checked) dane[nazwa] = el.value; continue; }
    if (typ === 'file') continue;
    dane[nazwa] = String(el.value == null ? '' : el.value);
  }
  return dane;
}
